import { useEffect, useState } from 'react'
import { Button, Col, DatePicker, Form, Input, Row, Select, Space, Table, Tooltip } from 'antd';
import systemConfig from '../../../../config/systematic';
import fetchApi from '../../../../utils/api/fetchApi';
import getList from '../../../universal/getList';
import moment from 'moment';
import TransferOrderEdit from '../../orderManagement/TransferOrderEdit';
import WebUniversalReport, { WUExtendPropsType } from '../../../system/WebUniversalReport';
import dayjs from 'dayjs';
import { showCustomNotification, useNotificationInstance } from '../../../../utils/extend/AntdNotificationEx';
import AntDraggableModal from '../../../../utils/extend/AntDraggableModal';



const { RangePicker } = DatePicker;
export default function PurOrderQuery() {
  /** 后端数据wmService */
  let wmService: any = systemConfig.wmService;
  const notificationApi = useNotificationInstance()
  const [memoOpen, setMemoOpen] = useState<boolean>(false);
  const [memoData, setMemoData] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [areaData, setAreaData] = useState<any>();

  const [aa, setAa] = useState<Array<any>>([
    {
      id: "productName",
      name: "品名"
    },
    {
      id: "selfId",
      name: "品号"
    },
    {
      id: "univalence",
      name: "单价"
    },
    {
      id: "totalPrice",
      name: "总价"
    }
  ])

  const [bb, setBb] = useState<Array<any>>([
    {
      id: "=",
      name: "相等"
    },
    {
      id: "like",
      name: "相似"
    }
  ])
  const [form] = Form.useForm();
  const form1 = Form.useForm()[0];
  /**打开调拨订单窗口 */
  /**传递收货订单的数据 */
  const [initValues, setInitValues] = useState<any>();
  const [dataTypeData, setDataTypeData] = useState<Array<any>>();


  /** 表头内容 */
  let columnsHead: any = [
    {
      title: "编号",
      dataIndex: "id",
      render: (text: any) => <Tooltip placement="topLeft" title={text}>{
        (typeof text !== "undefined" && text !== null) ?
          (text.length >= 8 ? text.substring(0, 6) + '....' : text)
          : ''
      }</Tooltip>
      // render: (text: any) => (text ? text.selfId ? text.selfId : "" : "")
    },

    {
      title: "单号",
      dataIndex: "orderId",

      render: (text: any) => <Tooltip placement="topLeft" title={text}>{
        (typeof text !== "undefined" && text !== null) ?
          (text.length >= 4 ? text.substring(0, 4) + '....' : text)
          : ''
      }</Tooltip>

    },
    {
      title: "日期",
      dataIndex: "createdAt",
      align: "center",

      render: (val: any, record: any) =>
        <span>
          {val ? moment(val).format('YYYY-MM-DD') : ""}
        </span>,

    },
    {
      title: "品号",
      dataIndex: "selfId",
    },

    {
      title: "品名",
      dataIndex: "productName",
    },
    {
      title: "单位",
      dataIndex: "productUnitName",
    },
    {
      title: "规格",
      dataIndex: "productSpecifications"
    },
    {
      title: "数量",
      dataIndex: "bNum",
      render: (text: any) => (text ? text.toFixed(2) : 0)
    },
    {
      title: "单价",
      dataIndex: "univalence",
      render: (text: any) => (text ? text.toFixed(2) : "")
    },
    {
      title: "总金额",
      dataIndex: "totalPrice",
      render: (text: any) => (text ? Number(text).toFixed(2) : 0)
    },
    {
      title: "备注",
      dataIndex: "memo",
      render: (text: any, record: any) => <Tooltip placement="topLeft" title={"点击修改备注"}>{
        <div onClick={() => openMemo(record)}>{text ? text : <span >.</span>}</div>
      }</Tooltip>
    },
    {
      title: '调入部门',
      dataIndex: 'importDeptName',
      align: "center",

    },
    {
      title: '打印数',
      dataIndex: 'printNumber',
      align: "center",

    },

  ]
  const onChangeMemo = (record: any) => {
    form1.validateFields()
      .then((values: any) => {

        fetchApi.POST(wmService, {
          apiId: "entrepot",
          apiExtend: "chageEmeo",
          apiData: {
            ...values,
            orderDetailId: memoData.orderDetailId,
            orderType: 3

          }
        }).then((res) => {
          setMemoOpen(false)
          setInitValues({ ...initValues, forcedRefresh: true })


        }).catch((err) => {
          setMemoOpen(false)
          showCustomNotification(notificationApi!, {
            type: "error",
            message: "修改失败",
            description: JSON.stringify(err)
          });
        })

      }).catch((err) => {
        showCustomNotification(notificationApi!, {
          type: 'warning',
          message: "无法通过数据校验",
          description: "请输入所需数据!"
        });
      })



  }
  const openMemo = (record: any) => {

    setMemoOpen(true)
    setMemoData({ orderDetailId: record.id })
    form1.setFieldsValue({ "memo": record?.memo })

  }
  useEffect(() => {

    //同步获取数据 async - await
    const fetchData = async () => {
      fetchApi.GET(wmService,
        {
          apiId: 'generalData',
          apiVariable: 'dataStatusType',
          apiExtend: 'showLists'
        }
      ).then(res => {
        if (res.success) {
          const { dataStatusType } = res.data


          setDataTypeData(dataStatusType)
        }
      })

      let areaData = await fetchApi.GET(wmService, {
        apiId: "area",
        apiExtend: 'showListManage',
        apiData: {
          mountDataOptions: {
            "userMount": {
              "isUserAreas": true,
              isDeptArea: true,
              isUserGroupAreas: true

            }
          },
        }
      })
      if (areaData.success) {
        setAreaData(areaData.data)
      }
      // setCaOrderStatusData
    };





    fetchData();
    //禁用规则
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); //初始化数据
  // const cc = (record: any, type: any) => {
  //   setTrOrderData({ id: record.orderId, type })
  //   setModalTrOrderOpen(true)
  // }
  // const onCloseTrOrderOpen = (status: Boolean) => {

  //   setModalTrOrderOpen(false)
  //   if (status === true) {
  //     initData(initValues)
  //   }
  // }

  // const initData = (values: any,currentEx?: number, pageSizeEx?: number) => {

  //   fetchApi.GET(
  //     wmService,
  //     {
  //       apiId: "entrepotReport",
  //       apiExtend: 'trOrderQuery',
  //       apiData: {
  //         ...values,
  //         pageSize: pageSizeEx ? pageSizeEx : pageSize,
  //         current: currentEx ? currentEx : current
  //       }
  //     }
  //   ).then(res => {
  //     setTotal(res.data.total)
  //     setPageSize(res.data.pageSize)
  //     setCurrent(res.data.current)
  //     setInitValues(values)
  //     setRows(res.data.rows)
  //     setLevel(res.data.level)
  //      showCustomNotification(notificationApi!, {
  //     type: 'success',
  //     message:"搜索成功",
  // description:  "success"
  // });;

  //   }).catch((err) => {
  //     console.log("err", err);

  //   })
  // }
  const onFinish = () => {
    setIsLoading(true)

    form.validateFields()
      .then((values: any) => {
        setInitValues({
          ...values,
          time: values.chooseTime ? {
            startTime: dayjs(values.chooseTime[0]).format("YYYY-MM-DD"),
            endTime: dayjs(values.chooseTime[1]).format("YYYY-MM-DD"),
          } : null,
          mountDataOptions: {
            userMount: {
              isEmployees: true,
              isDept: true,
              isUserAreas: true,
            }
          },
        })
        setIsLoading(false)

      }).catch((err) => {
        setIsLoading(false)

        showCustomNotification(notificationApi!, {
          type: 'warning',
          message: "无法通过数据校验",
          description: "请输入所需数据!"
        });;

      })
  }

  //    // 表格分页属性
  //    const paginationProps = {
  //     showSizeChanger: true,
  //     showQuickJumper: false,
  //     showTotal: () => `共${total}条`,
  //     pageSize,
  //     current,
  //     total,
  //     onShowSizeChange: (current: number, pageSize: number) => changePageSize(pageSize, current),
  //     onChange: (current: number) => changePage(current, pageSize),
  // };
  // // 回调函数，切换页数
  // const changePage = (current: number, pageSize: number) => {
  //     if (loading === false) {
  //         initData(initValues, current, pageSize)
  //         loading = true
  //     }
  // }

  // // 回调函数,每页显示多少条
  // const changePageSize = (pageSize: number, current: number) => {
  //     if (loading === false) {
  //         initData(initValues, current, pageSize)
  //         loading = true

  //     }
  // };
  let extendProps: WUExtendPropsType = {
    apiId: 'entrepotReport',
    apiExtend: "trOrderQuery",
    columns: columnsHead,
    pagination: true,
    values: initValues,
    printType: "transferOrderPrint",
    typeProducts: "transferProducts",
    primaryKeyName: "orderId",
    printApi: "transferOrder",
    EditComponent: TransferOrderEdit,
    isSummary:true
  };
  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
        initialValues={{ chooseTime: [dayjs().subtract(2, 'month'), dayjs()], dataStatusType: 1 }}
      >
        <Row>

          <Col span={3}>
            <Form.Item label="参数"
              name="parameters"
              rules={[{ required: true, message: '请选择参数!' }]}
            >
              <Select
                // mode="multiple"
                showSearch
                placeholder="参数"
                optionFilterProp="children"
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(aa, 'name')}
              </Select>
            </Form.Item>
          </Col>

          <Col span={3}>
            <Form.Item label="条件"
              name="condition"
              rules={[{ required: true, message: '请选择条件!' }]}
            >
              <Select
                // mode="multiple"
                showSearch
                placeholder="条件"
                optionFilterProp="children"
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(bb, 'name')}
              </Select>
            </Form.Item>
          </Col>

          <Col span={3}>
            <Form.Item label="参数值"
              name="parametersValue"
              rules={[{ required: true, message: '请输入参数值!' }]}
            >
              <Input />
            </Form.Item>
          </Col>


          <Col span={6}>
            <Form.Item
              label="日期"
              name="chooseTime"
            >
              <RangePicker

                format="YYYY-MM-DD"
              />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              label="调入区域"
              name="importAreaId"

            >
              <Select
                allowClear
                showSearch
                placeholder="调入区域"
                optionFilterProp="children"

                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(areaData, 'areaName')}
              </Select>
            </Form.Item>
          </Col>
          <Col span={2}>
            <Form.Item
              name="dataStatusType"
            >
              <Select
                defaultValue="数据状态"
                placeholder="数据状态"
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(dataTypeData)}
              </Select>
            </Form.Item>
          </Col>

          <Col span={2}>
            <Form.Item >
              <Space>
                <Button loading={isLoading} htmlType="submit">
                  统计
                </Button >
                {/* <Button onClick={() => DownloadExcel(prop, prop.data)} >
                                  下载EXCEL文件
                              </Button> */}
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      {memoOpen ? <AntDraggableModal
        title={"修改备注"}
        open={true}
        okText='确定'
        cancelText='取消'
        onOk={onChangeMemo}
        onCancel={() => setMemoOpen(false)}
        closable={false}
        maskClosable={false}
      >
        <Form

          form={form1}
          name="Edit"
          onFinish={onChangeMemo}
          onKeyDown={(e: any) => {
            if (e.key === 'Enter') {
              onChangeMemo(e)
            }
          }}>


          <Form.Item
            label="备注"
            name="memo"
            rules={[{ required: false, message: '请输入备注!' }]}>
            <Input />
          </Form.Item>



        </Form>
      </AntDraggableModal> : null}

      {/* <Button onClick={() => DownloadExcel(rows, "moonReport",queryCriteria)}>下载EXCEL文件</Button> */}
      {/* <div style={{ marginTop: "20px" }}>
        <Table
          // scroll={{ x: "100%", y: 650 }}
          pagination={paginationProps}
          rowKey={(record: any, index: any) => index}
          columns={columnsHead}
          dataSource={rows}

        >
        </Table>
        {modalTrOrderOpen ? (<TransferOrderEdit data={trOrderData} closeModal={onCloseTrOrderOpen}
        />)
          : null}
      </div> */}
      <WebUniversalReport props={extendProps}></WebUniversalReport>
    </>
  )
}
